import { AWSUser, UserType } from "@archetypes/auth";
import { Header } from "@components/header";
import { LeftMenu } from "@components/left-menu";
import StudioLayout from "@layouts/studio-layout";
import { useIsMinimumTablet } from "@hooks/use-media-query";
import { FC, useCallback } from "react";
import { Outlet, useLocation, Navigate, useOutletContext, useNavigate } from "react-router-dom";
import { useFavicon } from "@hooks/use-favicon";

export enum WorkSpaceEnum {
  ManageForm = "Forms",
  ManageDashboards = "Dashboards",
}

const isStudio = (pathname: string) => {
  if (
    pathname.includes("design") ||
    pathname.includes("templates") ||
    pathname.includes("responses") ||
    pathname.includes("rules") ||
    pathname.includes("preview") ||
    pathname.includes("layouts") ||
    pathname.includes("widgets")
  ) {
    return true;
  }
};

const AdminLayout: FC = () => {
  const user = useOutletContext<AWSUser>();
  const isMobile = !useIsMinimumTablet();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useFavicon("./logo.png");

  const onHeaderButtonClick = useCallback(() => {
    navigate("/builder/apps");
  }, [navigate]);

  if (user["custom:userType"] !== UserType.ADMIN || isMobile) {
    return <Navigate to="/apps" />;
  }
  const showTabs = pathname.endsWith("dashboards") || pathname.endsWith("forms");
  return (
    <>
      {!isStudio(pathname) ? (
        <main className="main-container">
          <div className="menu-area">
            <LeftMenu />
          </div>
          <div className="content-area">
            <div className="header-area">
              <Header
                basePath="/builder"
                user={user}
                onHeaderButtonClick={onHeaderButtonClick}
                {...(showTabs && {
                  tabsArray: [WorkSpaceEnum.ManageForm, WorkSpaceEnum.ManageDashboards],
                })}
              />{" "}
            </div>
            <Outlet />
          </div>
        </main>
      ) : (
        <StudioLayout />
      )}
    </>
  );
};

export default AdminLayout;
